// extracted by mini-css-extract-plugin
export default {"row":"A8MlhfvRsudXM7LdmV6T","inBox":"eLxetnEe1ONLq___avhA"};